export default "__VITE_ASSET__CuA$nSGv__"